var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnivNantes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.35) translate(0, -400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1457.28,1076.64 v 46.78 h 293.84 v -46.78 c 0,-331.511 -258.68,-591.441 -591.44,-591.441 -331.512,0 -590.192,259.93 -590.192,591.441 v 46.78 l 293.84,0.04 v -46.82 c 0,-180.831 125.57,-311.41 296.352,-311.41 172.03,0 297.6,130.579 297.6,311.41",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1751.12,1359.75 v 600.22 h -276.26 v -408.11 l -205.29,408.11 H 962.527 l 310.293,-600.22 h 478.3",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 857.051,1359.75 H 569.488 v 600.22 h 287.563 v -600.22",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnivNantes);
export default __webpack_public_path__ + "static/media/univ-nantes.75d1a11eef1a0dbd0357b71d80de9ce2.svg";
export { ForwardRef as ReactComponent };